import { ThreeBounce } from 'better-react-spinkit';
import { Spinner } from 'components/spinner/Spinner';
import React from 'react';

type PopoutMenuFooterProps = {
  handlePrimaryButtonClick?: () => void;
  handleSecondaryButtonClick?: () => void;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  primaryBtnColor?: string;
  isSubmitting?: boolean;
};

export const PopoutMenuFooter: React.FC<PopoutMenuFooterProps> = ({
  handlePrimaryButtonClick,
  handleSecondaryButtonClick,
  primaryButtonText,
  secondaryButtonText,
  primaryBtnColor,
  isSubmitting,
}) => {
  const btnColour = primaryBtnColor ? primaryBtnColor : 'BtnOrange';

  return (
    <div className="PopoutMenuFooter">
      {secondaryButtonText && handleSecondaryButtonClick && 
        <button
          className="Btn BtnGrey SecondaryButton"
          onClick={handleSecondaryButtonClick}
        >
          {secondaryButtonText}
        </button>
      }
      <button
        type="button"
        className={'Btn PrimaryButton ' + btnColour}
        onClick={handlePrimaryButtonClick && handlePrimaryButtonClick}
        disabled={isSubmitting ? true : false}
      >
        {isSubmitting ? (
          <ThreeBounce size={10} color={'#ffffff'} />
        ) : (
          primaryButtonText
        )}
      </button>
    </div>
  );
};
